module.exports = __webpack_public_path__ + "img/AS3485023.b87a7e12.jpg";